var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelledOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.505,
    height: 19.516,
    viewBox: "0 0 19.505 19.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(-0.139 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "translate(5.742 8.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M148.294,229.206a1.412,1.412,0,1,0,1.15,1.387A1.287,1.287,0,0,0,148.294,229.206Zm0,2.2c-.313,0-.578-.373-.578-.815s.265-.815.578-.815.578.373.578.815S148.607,231.408,148.294,231.408Z",
    transform: "translate(-147.144 -229.206)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(11.738 8.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M305.587,229.207a1.412,1.412,0,1,0,1.15,1.387A1.287,1.287,0,0,0,305.587,229.207Zm0,2.2c-.313,0-.578-.373-.578-.815s.265-.815.578-.815.578.373.578.815S305.9,231.409,305.587,231.409Z",
    transform: "translate(-304.437 -229.207)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(7.664 12.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M201.989,338.949a2.418,2.418,0,0,0-4.4,0,.286.286,0,0,0,.521.237,1.846,1.846,0,0,1,3.358,0,.286.286,0,1,0,.521-.236Z",
    transform: "translate(-197.563 -337.533)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(12.203 6.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M319.07,181.322a3,3,0,0,0-2.139-.862.286.286,0,0,0,.012.572,2.436,2.436,0,0,1,1.732.7.286.286,0,1,0,.4-.413Z",
    transform: "translate(-316.651 -180.46)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    transform: "translate(5.069 6.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M131.7,180.46a3,3,0,0,0-2.139.862.286.286,0,1,0,.4.413,2.44,2.44,0,0,1,1.686-.7h.052a.286.286,0,0,0,.006-.572Z",
    transform: "translate(-129.477 -180.459)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    transform: "translate(3.641 11.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M95.3,312.738l-.123-.246a.286.286,0,0,0-.511.256l.119.238a1.159,1.159,0,0,1-1.092,1.6,1.12,1.12,0,0,1-1-1.581l1.094-2.022.283.567a.286.286,0,0,0,.511-.256l-.3-.61a.545.545,0,0,0-.48-.3h-.009a.545.545,0,0,0-.481.287c-1.187,2.2-1.122,2.073-1.13,2.089a1.693,1.693,0,0,0,1.539,2.4A1.732,1.732,0,0,0,95.3,312.738Z",
    transform: "translate(-92.016 -310.38)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(4.232 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M121.637,4.88a9.75,9.75,0,0,0-13.981-3.156.286.286,0,0,0,.324.471,9.184,9.184,0,0,1,11.3,14.44.286.286,0,1,0,.378.429A9.762,9.762,0,0,0,121.637,4.88Z",
    transform: "translate(-107.532 0)",
    fill: "#ff2c3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "translate(0.139 2.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M15.342,80.72a.286.286,0,0,0-.4-.082c-.158.1-.314.2-.465.288A9.183,9.183,0,0,1,3.668,66.219a.286.286,0,0,0-.387-.421,9.755,9.755,0,0,0,11.98,15.319A.286.286,0,0,0,15.342,80.72Z",
    transform: "translate(-0.139 -65.722)",
    fill: "#ff2c3d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledOrder);
export default __webpack_public_path__ + "static/media/cancelled-order.4d7c644b774b18d027184e7609bcd22f.svg";
export { ForwardRef as ReactComponent };